module.exports = __webpack_public_path__ + "img/box.1834e58a.gif";